import formatsIndex from '@/assets/formats/index'
import keirekishoFormatsIndex from '@/assets/formats/keirekisho_index'
import rirekishoFormatsIndex from '@/assets/formats/rirekisho_index'
import letterFormatsIndex from '@/assets/formats/letter_index'
import etcFormatsIndex from '@/assets/formats/etc_index'
import { getFormatById } from '@/utils/format-edit/getFormatById'
const Site = {
  install: function (Vue, _options) {
    Vue.prototype.$site = {
      name: process.env.VUE_APP_SITE_NAME,
      id: process.env.VUE_APP_SITE_ID,
      isDevelop: process.env.NODE_ENV === 'development',
      isProduction: process.env.NODE_ENV === 'production',
      blogJsonUrl: process.env.VUE_APP_BLOG_RSS_JSON_URL,
      formatsIndex,
      keirekishoFormatsIndex,
      rirekishoFormatsIndex,
      letterFormatsIndex,
      etcFormatsIndex,
      getFormatById,
      appFlag: process.env.VUE_APP_DEVICE_MODE,
      siteFlag: process.env.VUE_APP_SITE_FLAG
    }
  }
}
export default Site
